import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import LogoImage from "../../images/asserts/Dashboard Assets/Logo.webp";
import img2 from "../../images/asserts/Dashboard Assets/image1-min.webp";
import i18n from "../../i18n";
import { LanguagesIcon } from "lucide-react";
const languages = [
  { code: "en", lng: "English" },
  { code: "ar", lng: "Arabic" },
];
function UpdatePassword(): JSX.Element {
  const { token } = useParams<{ token: string }>();
  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLanguageDropdownVisible, setIsLanguageDropdownVisible] = useState(false);
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
    document.body.className = lng === "ar" ? "lang-ar" : "lang-en";
    setIsLanguageDropdownVisible(false);
  };

  useEffect(() => {
    const lang = localStorage.getItem("i18nextLng");
    if (!lang || lang === "en-US") {
      localStorage.setItem("i18nextLng", "en");
      window.location.reload();
    };
  }, [])

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setMessage("Passwords do not match");
      setIsError(true);
      return;
    }
    setIsLoading(true);
    try {
      await axios.post(
        "https://api.nadwa-uae.com/api/v2/users/password/reset/confirm/",
        {
          password: newPassword,
          token: token,
        }
      );
      setMessage("Password updated successfully");
      setIsError(false);
    } catch (error: any) {
      if (error.response && error.response.data.global) {
        setMessage(error.response.data.global);
      } else {
        setMessage("Failed to update password");
      }
      setIsError(true);
    }
    setIsLoading(false);
  };

  return (
    <div>
      <header className={`flex justify-between ${i18n.language == "ar" ? "flex-row-reverse" : "flex-row"} items-center py-3 px-8 border-b border-gray-200 sticky top-0 bg-white z-20`}>
        <img src={LogoImage} alt="Logo" className="w-32" />
        <div className="relative">
          <button
            onClick={() => setIsLanguageDropdownVisible(!isLanguageDropdownVisible)}
            className={`flex items-center gap-2 border border-[#008847] px-3 py-1 rounded ${i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
              }`}
          >
            <LanguagesIcon className="w-4 h-4" />
            {i18n.language === "ar" ? "العربية" : "English"}
          </button>
          {isLanguageDropdownVisible && (
            <ul className="absolute right-0 mt-2 w-40 bg-white text-[#008847] rounded-lg shadow-md z-10">
              {languages.map((language) => (
                <li
                  key={language.code}
                  onClick={() => changeLanguage(language.code)}
                  className="cursor-pointer px-4 py-2 hover:bg-[#008847] hover:text-white transition-colors duration-200"
                >
                  {language.lng}
                </li>
              ))}
            </ul>
          )}
        </div>
      </header >
      <div
        dir={i18n.language === "ar" ? "rtl" : "ltr"}
        className="flex justify-center items-center py-20">
        {/* Left Section */}
        <div className="w-[40%] h-[80%] flex flex-col justify-center p-10 bg-white">
          
          <h2 className="text-3xl font-semibold mb-2">
            {i18n.language === "ar" ? "تغيير كلمة المرور" : "Set New Password"}
          </h2>
          <p className="text-gray-600 mb-6">
            {i18n.language === "ar"
              ? "يرجى استخدام النموذج أدناه لتغيير كلمة المرور"
              : "Please use the form below to change your password"}
          </p>
          <form className="w-full" onSubmit={handleSubmit}>
            <label className="block text-gray-700 mb-1">
              {i18n.language === "ar" ? "كلمة المرور الجديدة" : "New Password"}
            </label>
            <input
              type="password"
              placeholder={
                i18n.language === "ar"
                  ? "كلمة المرور الجديدة"
                  : "Enter New Password"
              }
              className="w-4/5 py-2 px-3 border border-gray-300 rounded-3xl mb-4 focus:outline-none focus:ring-2 focus:ring-green-500"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <label className="block text-gray-700 mb-1">
              {i18n.language === "ar" ? "تأكيد كلمة المرور" : "Confirm Password"}
            </label>
            <input
              type="password"
              placeholder={
                i18n.language === "ar" ? "تأكيد كلمة المرور" : "Confirm Password"
              }
              className="w-4/5 py-2 px-3 border border-gray-300 rounded-3xl mb-4 focus:outline-none focus:ring-2 focus:ring-green-500"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <button
              type="submit"
              className="w-4/5 bg-green-700/90 text-white py-2 rounded-3xl text-lg hover:bg-green-700"
              disabled={isLoading}
            >
              {isLoading
                ? `${i18n.language === "ar" ? "تحديث" : "Updating..."}`
                : `${i18n.language === "ar"
                  ? "تغيير كلمة المرور"
                  : "Change Password"
                }`}
            </button>
          </form>
          {message && (
            <p
              className={`mt-4 text-sm ${isError ? "text-red-600" : "text-green-600"
                }`}
            >
              {message}
            </p>
          )}
        </div>

        <div className="w-[42%] h-[80%]">
          <img
            src={img2}
            alt="Green Section"
            className="w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  );
}

export default UpdatePassword;
